export default __webpack_public_path__ + "static/media/service001.cb093d95.jpg";